// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CancelWorkflowRequestModel {
    static getAttributeTypeMap() {
        return CancelWorkflowRequestModel.attributeTypeMap;
    }
}
CancelWorkflowRequestModel.discriminator = undefined;
CancelWorkflowRequestModel.attributeTypeMap = [
    {
        "name": "patientAccountId",
        "baseName": "patientAccountId",
        "type": "number"
    },
    {
        "name": "workflowId",
        "baseName": "workflowId",
        "type": "number"
    },
    {
        "name": "caseTypeStatusRelationshipId",
        "baseName": "caseTypeStatusRelationshipId",
        "type": "number"
    },
    {
        "name": "reason",
        "baseName": "reason",
        "type": "string"
    }
];
//# sourceMappingURL=cancelWorkflowRequestModel.js.map